import { useState, useRef } from 'react'
import ReactPlayer from 'react-player'
import {
    Box, Center, VStack, HStack, Button, Spinner, useToast
  } from '@chakra-ui/react';
import _price from '../lib/price'
import {getAttribute} from '../lib/meta'
import usdcImg from '../images/USDC_32.webp'
import {useWeb3React } from "@web3-react/core"
import {toDec, toBN} from '../lib/bn'
import nfts from '../lib/nfts'

const Buy = (props) => {
    const {account, library} = useWeb3React()
    const [processing, setProcessing] = useState(false)

    let sufficientFunds = false
    let bnPrice // = toBN(0)
    const toast = useToast()
    const toastIdRef = useRef()

    if(props.usdc){
        bnPrice = toBN(props.price,6)
        sufficientFunds = bnPrice.lte(props.usdc)
    }
    
    const approve = async () => {
        setProcessing(true)
        toastIdRef.current = toast({
            title: 'Approval pending',
            status: 'info',
            isClosable: true,
            duration: 120000
        })
        try{
            let tx = await nfts.USDC.approve(library.getSigner(account),nfts.yieldSale.address,toBN(2).pow(256).sub(1))
            toast.update(toastIdRef.current,{
                title: 'Sent approval tx to blockchain. Awaiting confirmation',
                status: 'info',
                isClosable: true,
                duration: 120000
            })
            await nfts.confirm(tx.hash)
            toast.update(toastIdRef.current,{
                title: 'Approval successful',
                status: 'success',
                isClosable: true,
                duration: 2000
            })
            console.log('here')
            await props.updateAllowance()
            
            setProcessing(false)
            
        } catch(e){
            console.log(e)
            toast.update(toastIdRef.current,{
                title: 'Something went wrong. Please try again.',
                status: 'error',
                isClosable: true,
                duration: 2000,
                
            })
            setProcessing(false)
        }
        
    }

    const buy = async () => {
            
        setProcessing(true)
        toastIdRef.current = toast({
            title: 'Buy pending',
            status: 'info',
            isClosable: true,
            duration: 120000
        })
        try{
            console.log('tokenID: ' + props.tokenId)
            console.log(library.getSigner(account))
            console.log('attempting buy')
            let tx = await nfts.yieldSale.buy(library.getSigner(account),toBN(props.tokenId))
            toast.update(toastIdRef.current,{
                title: 'Sent tx to blockchain. Awaiting confirmation',
                status: 'info',
                isClosable: true,
                duration: 120000
            })
            await nfts.confirm(tx.hash)
            toast.update(toastIdRef.current,{
                title: 'Buy successful',
                status: 'success',
                isClosable: true,
                duration: 2000
            })
            props.done()
            setProcessing(false)
        } catch(e){
            console.log(e)
            toast.update(toastIdRef.current,{
                title: e.message,
                status: 'error',
                isClosable: true,
                duration: 2000,
                
            })
            setProcessing(false)
        }
        
    }

    return (
        <div style={{padding: 10, marginTop: 20, marginLeft: 20, border: 'solid 1px #e5e8eb', borderRadius: 10, backgroundColor: '#fbfdff', width: 350}}>
            <div style={{fontSize: 14}}>Current Price</div>
            <div style={{marginTop: 5}}>
                <img alt='price' src={usdcImg} style={{width: 25, height: 25, display: 'inline-block', position: 'relative', top: 3, marginLeft: 2, marginRight: 3}} /> 
                <div style={{display: 'inline-block', position: 'relative', top: 0, marginLeft: 2, fontSize: 30, fontWeight: 'bold'}}>{props.price}</div>
                <div style={{display: 'inline-block', position: 'relative', top: 0, marginLeft: 5, fontSize: 12}}>USDC</div>
                {!props.active && 
                    <div style={{color: 'red', fontSize: 12, textAlign: 'center', marginTop: 10}}>Please connect your wallet</div>
                }
                {props.usdc && props.active && props.allowance &&
                    <>
                    <div style={{color: (sufficientFunds)?'#666666':'red', marginLeft: 10, fontSize: 10, display: 'block'}}><b>Balance:</b> {toDec(props.usdc,6)} USDC</div>
                    <Center style={{marginTop: 20, marginBottom: 10}}>
                        <Button colorScheme='blue' variant={(props.allowance.gte(bnPrice))?'solid':'outline'} isLoading={processing} onClick={(props.allowance.gte(bnPrice))?buy:approve} disabled={!sufficientFunds}>{(props.allowance.gte(bnPrice))?'Buy Now':'Approve Spend'}</Button>
                    </Center>
                    </>
                }
                
            </div>
        </div>
    )
}

const BuyNFT = (props) => {
    const {account, library, active} = useWeb3React()
    const level = parseInt(getAttribute(props.meta,'Level'))
    const price = level * _price
    let usdc = props.usdc
    console.log(props.tokenId)
    console.log(props.hasAccessToken)
    return (
        <div style={{marginTop: 20}}>
            <HStack>
                <div style={{height: 520, width: 420, borderRadius: 10, overflow: 'hidden', boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)'}}>
                    <ReactPlayer url={props.meta.animation_url} playing loop height={530} width={450} style={{position: 'relative', left: -5, top: -5}} />
                </div>
                <div style={{ height: 535, width: 380, padding: 10}}>
                    <div style={{marginLeft: 20, marginTop: 20, color: '#1f82e2', cursor: 'pointer'}}  onClick={props.back}>{'<-'} Bitmart Yield Tokens</div>
                    <div style={{fontSize: 30, fontWeight: 'bold', marginLeft: 20, marginTop: 10}}>{props.meta.name}</div>
                    <div style={{marginLeft: 20, marginTop: 10}}>{props.meta.description}</div>
                    {!props.tokenId && 
                        <div style={{marginLeft: 20, marginTop: 10}}><Spinner size='xs' /> Loading tokenId..</div>
                    }
                    {props.tokenId &&
                        <div style={{marginLeft: 20, marginTop: 10}}>TokenId: {props.tokenId}</div>
                    }
                    {props.hasAccessToken===-1 && 
                        <div style={{marginLeft: 20, marginTop: 10}}><Spinner size='xs' /> Checking Access Token...</div>
                    }
                    {props.hasAccessToken===0 && 
                        <div style={{marginLeft: 20, marginTop: 10, color: 'red'}}>You need an Access Token to purchase a Yield Token</div>
                    }
                    {props.tokenId && props.hasAccessToken===1 &&
                        <Buy price={price} isLoading={!(props.tokenId && props.tokenId!==-1) && !usdc} account={account} usdc={usdc} active={active} allowance={props.allowance} library={library} updateAllowance={props.updateAllowance} tokenId={props.tokenId} done={props.done}/>
                    }
                    

                    
                </div>
                
                
            </HStack>
        </div>
        
    )
}

export default BuyNFT